import { useLayoutEffect } from "react";
import { Maximize2, Minimize2, Minus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTeamWorkspaceFrame } from "./team-workspace-frame-context";

/** The two window buttons, without registering; the window uses it for its fallback strip. */
export function FrameButtons() {
  const frame = useTeamWorkspaceFrame();
  if (!frame) return null;
  return <>
    <Button variant="ghost" size="icon" className="hidden min-h-11 min-w-11 sm:inline-flex sm:min-h-11" aria-label={frame.fullScreen ? "Restaurar tamanho da janela" : "Expandir espaço da equipe"} aria-pressed={frame.fullScreen} onClick={frame.toggleFullScreen}>{frame.fullScreen ? <Minimize2 className="size-4" aria-hidden /> : <Maximize2 className="size-4" aria-hidden />}</Button>
    <Button variant="ghost" size="icon" className="min-h-11 min-w-11 sm:min-h-11" aria-label="Minimizar espaço da equipe" aria-expanded="true" disabled={frame.blocked} onClick={frame.minimize}><Minus className="size-4" aria-hidden /></Button>
  </>;
}

/** Expand/restore and minimize, rendered by the content header; absent outside the window. */
export function TeamWorkspaceFrameControls() {
  const register = useTeamWorkspaceFrame()?.register;
  useLayoutEffect(() => register?.(), [register]);
  return <FrameButtons />;
}
